// Turn an axios error into ONE concise, actionable toast message.
// The backend's validation errors ship `{ error: 'Validation failed', details: [...] }`;
// surfacing only `error` gives the operator zero signal about WHAT failed. Append the
// first detail, e.g. "Validation failed — geometry.coords: Expected array, received null".

function detailPath(d: any): string | null {
  if (Array.isArray(d?.path) && d.path.length > 0) return d.path.join('.');
  if (typeof d?.path === 'string' && d.path) return d.path;
  if (typeof d?.field === 'string' && d.field) return d.field;
  return null;
}

function detailMessage(d: any): string | null {
  if (typeof d === 'string' && d) return d;
  if (typeof d?.message === 'string' && d.message) return d.message;
  if (typeof d?.msg === 'string' && d.msg) return d.msg;
  return null;
}

export function apiErrorMessage(err: any, fallback: string): string {
  const base: string = err?.response?.data?.error || fallback;
  const details = err?.response?.data?.details;
  if (Array.isArray(details) && details.length > 0) {
    const msg = detailMessage(details[0]);
    if (msg) {
      const path = detailPath(details[0]);
      return path ? `${base} — ${path}: ${msg}` : `${base} — ${msg}`;
    }
  }
  return base;
}
